import { User } from 'next-firebase-auth';
import { getUserSubscription } from '@requests/subscriptions';
import { queryKeySubscriptions } from '@utils/react-query-keys';
import {
  hasActiveMaxSubscription,
  hasActiveSubscription,
} from '@utils/subscription-utils';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Subscription } from '@customtypes/subscription';

export type SubscriptionStatusType =
  | 'not active'
  | 'active PRO'
  | 'active MAX'
  | 'loading';

const useSubscriptionStatus = (user: User) => {
  const { data: subscriptionData, isError } = useQuery({
    queryKey: [queryKeySubscriptions],
    queryFn: () => getUserSubscription(user),
  });

  const [subscriptionStatus, setSubscriptionStatus] =
    useState<SubscriptionStatusType>(
      subscriptionData?.subscriptions
        ? getSubscriptionStatus(subscriptionData.subscriptions)
        : 'loading',
    );

  useEffect(() => {
    if (subscriptionData) {
      setSubscriptionStatus(
        getSubscriptionStatus(subscriptionData.subscriptions),
      );
    }
  }, [subscriptionData]);

  useEffect(() => {
    if (isError) {
      setSubscriptionStatus('not active');
    }
  }, [isError]);

  return [subscriptionStatus];
};

export default useSubscriptionStatus;

export function getSubscriptionStatus(subscriptions: Subscription[]) {
  return hasActiveMaxSubscription(subscriptions)
    ? 'active MAX'
    : hasActiveSubscription(subscriptions)
      ? 'active PRO'
      : 'not active';
}
